import * as React from 'react'
import { useHydrated } from 'hooks/use-hydrated'
import type { Condition, FeatureFlagCondition } from '../types'
import { hasElementBeenEdgeTrimmed } from '../utils/has-element-been-edge-trimmed'
import {
  isClientSideVariantSelection,
  isHtmlRenderVariantSelection,
} from '../utils/rendering-selection-state'

export function useExperimentEvents(conditions: Condition[], htmlId: string, isVisible: boolean) {
  const isHydrated = useHydrated()

  React.useEffect(() => {
    if (!isHydrated) {
      return
    }

    if (hasElementBeenEdgeTrimmed(htmlId)) {
      return
    }

    if (isClientSideVariantSelection() || isHtmlRenderVariantSelection()) {
      // oxlint-disable-next-line unicorn/no-lonely-if
      if (!isVisible) {
        return
      }
    }

    const featureFlagConditions = conditions.filter(
      condition => condition.type === 'feature-flag',
    ) as FeatureFlagCondition[]

    featureFlagConditions.forEach(condition => {
      if (typeof condition.expectedValue === 'boolean') {
        window.globalGrowthBook?.isOn(condition.featureName)
      } else {
        window.globalGrowthBook?.getFeatureValue(condition.featureName)
      }
    })
  }, [isHydrated, conditions, htmlId, isVisible])
}
